import React from 'react'
import { MenuContainer, Welcome } from './Styled'
import Menu from './menu/Menu'
import HomeLayout from '../layouts/homeLayout/HomeLayout'

type HomeProps = {}

export const Home: React.FunctionComponent<HomeProps> = props => {
    return (
      <HomeLayout
      title='Botstation'
      subTitle=''
  >
            <MenuContainer>
                <Menu />
            </MenuContainer>
        </HomeLayout>
    )
}

export default Home
